import * as React from 'react';
import { Tooltip } from "react-tooltip";
import groupBy from 'lodash-es/groupBy';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FigureOptions, PointOptions, SegmentOptions } from 'peaks.js';

export interface EventTotalsProps {
    pointEvents: Array<PointOptions>;
    periodEvents: Array<SegmentOptions>;
    isDisputedView?: boolean;
}


export const EventTotals = (props: EventTotalsProps) => {
    const renderEventTypes = (eventTypeGroup): Array<React.ReactNode> => {
        const listItems: Array<React.ReactNode> = [];

        for (var property in eventTypeGroup) {
            const group: FigureOptions[] = eventTypeGroup[property];

            const duplicateEvents = group.filter(x => x.withinDuplicateThreshold && !x.confirmedValidDuplicate);

            listItems.push(
                <li key={property} className="list-group-item col-xs-4">
                    <span className="badge badge-info">{group.length}</span>
                    {duplicateEvents.length > 0 && props.isDisputedView === false ? <><span className="badge badge-warning" data-tooltip-id="DuplicateThresholdGlobalWarningTooltip"><FontAwesomeIcon icon={faTriangleExclamation} />&nbsp;{duplicateEvents.length}</span>
                        <Tooltip id="DuplicateThresholdGlobalWarningTooltip" style={{ zIndex: 2500 }}>
                            Events within the duplicate threshold are present in the recording
                        </Tooltip></> : null}
                    {group[0].eventTypeName}
                </li>
            );
        }
        return listItems;
    }

    const groupedPointEvents = groupBy(props.pointEvents, 'eventTypeId');
    const groupedPeriodEvents = groupBy(props.periodEvents, 'eventTypeId');

    const groupedAll = Object.assign({}, groupedPointEvents, groupedPeriodEvents);

    return (
        <>
            <h3 className="text-primary">{props.isDisputedView === false ? "Total Events" : "Total Disputed Events" }</h3>
            <ul className="list-group">
                {renderEventTypes(groupedAll)}
            </ul>
        </>
    );
}
